import { useEffect, useMemo, useState } from "react";
import { IVehicle, PartsStatusDropdowns, PartsStatusValues } from "../../models/Vehicle";
import DashboardTile from "../dashboard/DashboardTile";
import { ILead } from "../../models/Lead";
import useVehicleStats from "../../data/useVehicleStats";
import { setEngine } from "crypto";
import { DateTime } from "luxon";
import DashboardStat from "../dashboard/DashboardStat";
import DashboardTileMultiple from "../dashboard/DashboardTileMultiple";
import { CheckFeatureFlag } from "../../hooks/useFeatureFlag";


export default function VehicleStats() {
  const { stats } = useVehicleStats();
  const hasTmeFeature = CheckFeatureFlag("TME");

  const partsStatus = [
    ...Object.values(PartsStatusDropdowns).filter((ct) => isNaN(Number(ct))),
  ];

  const memoStats = useMemo(() => {
    if (stats.isLoading || !stats.data) return;
    return stats.data.data;
  }, [stats.isLoading, stats.data]);

  return (
    <div className="bg-white shadow rounded p-4 mt-4 grid gap-4 grid-cols-1 grid-rows-1 sm:grid-rows-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-5">

      {!hasTmeFeature && (
        <div className="row-span-2 h-full rounded bg-teal-100 text-teal-600 p-2 px-4 prose-base">
          <h1 className="mb-1 font-semibold">Parts Status</h1>
          <ul className="p-0 text-sm">
            {partsStatus.map((status, i) => (
              //@ts-ignore
              <li key={i} className="!m-0">
                {status}:{" "}
                {
                  memoStats?.engineExportCounts?.find(
                    (count) =>
                      count.status ===
                      //@ts-ignore
                      PartsStatusValues[status]
                  )?.count
                }
              </li>
            ))}
          </ul>
        </div>
      )}

      <DashboardStat
        title={memoStats?.awaitingInventory.toString() ?? "0"}
        desc="Awaiting Schedule"
        color="emerald"
      />

      <DashboardStat
        title={memoStats?.awaitingDismantling.toString() ?? "0"}
        desc="Awaiting Dismantling"
        color="lime"
      />

      <DashboardStat
        title={memoStats?.awaitingCOD.toString() ?? "0"}
        desc="Awaiting COD"
        color="slate"
      />

      <DashboardStat
        title={memoStats?.startsAndDrives.toString() ?? "0"}
        desc="Starts & Drives"
        color="purple"
      />

      <DashboardStat
        title={memoStats?.addedToday.toString() ?? "0"}
        desc="Added Today"
        color="blue"
      />

{/* 
      <div className={`h-full rounded bg-emerald-100 text-emerald-600 p-2 px-4 prose-base`} >
        <h1 className="text-emerald-600 font-semibold">{memoStats?.awaitingInventory}</h1>
        <p className="!m-0">Awaiting Schedule</p>
      </div>

      <div className={`h-full rounded bg-lime-100 text-lime-600 p-2 px-4 prose-base`} >
        <h1 className="text-lime-600 font-semibold">{memoStats?.awaitingDismantling}</h1>
        <p className="!m-0">Awaiting Dismantling</p>
      </div>

      <div className={`h-full rounded bg-slate-100 text-slate-600 p-2 px-4 prose-base`} >
        <h1 className="text-slate-600 font-semibold">{memoStats?.awaitingCOD}</h1>
        <p className="!m-0">Awaiting COD</p>
      </div>

      <div className={`h-full rounded bg-purple-100 text-purple-600 p-2 px-4 prose-base`} >
        <h1 className="text-purple-600 font-semibold">{memoStats?.startsAndDrives}</h1>
        <p className="!m-0">Starts & Drives</p>
      </div>

      <div className={`h-full rounded bg-blue-100 text-blue-600 p-2 px-4 prose-base`} >
        <h1 className="text-blue-600 font-semibold">{memoStats?.addedToday}</h1>
        <p className="!m-0">Added Today</p>
      </div> */}

      {/* <div className={`h-full rounded bg-amber-100 text-amber-600 p-2 px-4 prose-base`} >
        <h1 className="text-amber-600 font-semibold">{memoStats?.awaitingCollection}</h1>
        <p className="!m-0">Awaiting Collection</p>
      </div> */}

      <DashboardTileMultiple
        colour="amber"
        values={[
          memoStats?.awaitingCollection?.toString()      ?? "0",
          memoStats?.awaitingCollectionToday?.toString() ?? "0",
        ]}
        labels={[
          "Awaiting Collection",
          "Awaiting Collection",
        ]}
        subLabels={["All", "Today"]}
        borderless={true}
        // className={spanClass}
      />

      <DashboardStat
        title={memoStats?.collectedToday.toString() ?? "0"}
        desc="Collected Today"
        color="green"
      />

      <DashboardTileMultiple
        colour="rose"
        values={[
          memoStats?.awaitingDropOff?.toString()      ?? "0",
          memoStats?.awaitingDropOffToday?.toString() ?? "0",
        ]}
        labels={[
          "Awaiting Drop Off",
          "Awaiting Drop Off",
        ]}
        subLabels={["All", "Today"]}
        borderless={true}
        // className={spanClass}
      />

      {/* <div className={`h-full rounded bg-green-100 text-green-600 p-2 px-4 prose-base`} >
        <h1 className="text-green-600 font-semibold">{memoStats?.collectedToday}</h1>
        <p className="!m-0">Collected Today</p>
      </div>

      <div className={`h-full rounded bg-rose-100 text-rose-600 p-2 px-4 prose-base`} >
        <h1 className="text-rose-600 font-semibold">{memoStats?.awaitingDropOff}</h1>
        <p className="!m-0">Awaiting Drop Off</p>
      </div> */}



    </div>
  );
}